import React from 'react';
import { t } from 'i18next';
import * as Yup from 'yup';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { ErrorMessage, Field, Formik, Form as FormikForm } from 'formik';
import RequiredAstric from '../../../../components/DynamicForm/required-astric';

const validationSchema = Yup.object().shape({
	name: Yup.string().required('Name is required')
});

const TemplateModel = ({ show, close, submitTemplate, isEdit = false  }) => {

	const handleClose = () => {
		close();
	};

	const handleSubmit = async(values, { setSubmitting, resetForm }) => {
		try {
			submitTemplate(values.name);
			resetForm();
		} catch (error) {
			return error;
		}
		setSubmitting(false);
	};

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" centered >
			<Modal.Header closeButton>
				<Modal.Title>{t('GENERAL.ADD')} Template </Modal.Title>
			</Modal.Header>

			<Formik
				initialValues={{
					name: ''
				}}
				validationSchema={validationSchema}
				enableReinitialize={true}
				onSubmit={handleSubmit}
			>
				{({ isSubmitting }) => (
					<FormikForm>
						<Modal.Body>
							<Row className="mb-3">
								<Form.Group>
									<Form.Label>Name <RequiredAstric /></Form.Label>
									<Field name="name" as="input" className="form-control" />
									<div className="text-danger small"><ErrorMessage name="name" /></div>
								</Form.Group>
							</Row>

							<Row className="mb-3">
								<Col>
									<Button type="submit" className='px-3 py-2 me-2' variant="primary" disabled={false}>
										{isSubmitting ? t('GENERAL.SAVING') : isEdit ? t('GENERAL.UPDATE') : t('GENERAL.SUBMIT')}
									</Button>
									<Button variant="danger" className='px-3 py-2' onClick={handleClose}>{t('GENERAL.CANCEL')}</Button>
								</Col>
							</Row>
						</Modal.Body>
					</FormikForm>
				)}
			</Formik>
		</Modal >
	);
};

export default TemplateModel;
